import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrExpansionPanelModule } from '../pr-expansion-panel/pr-expansion-panel.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrLabelModule } from '../pr-label/pr-label.module';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
import { PrPaginationV2Module } from '../pr-pagination-v2/pr-pagination-v2.module';
import { PrSearchInputModule } from '../pr-search-input/pr-search-input.module';
import { PrSeparatorModule } from '../pr-separator/pr-separator.module';
import { PrTooltipIconModule } from '../pr-tooltip-icon/pr-tooltip-icon.module';
import { PrListItemColumnComponent } from './pr-list-item/pr-list-item-column/pr-list-item-column.component';
import { PrListItemComponent } from './pr-list-item/pr-list-item.component';
import { PrListComponent } from './pr-list.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    PrListComponent,
    PrListItemComponent,
    PrListItemColumnComponent,
  ],
  imports: [
    CommonModule,
    PrExpansionPanelModule,
    MatExpansionModule,
    PrTooltipIconModule,
    PrLabelModule,
    PrIconModule,
    PrPaginationV2Module,
    PrSearchInputModule,
    PrSeparatorModule,
    PrLoaderModule,
  ],
  exports: [PrListComponent, PrListItemComponent, PrListItemColumnComponent],
})
export class PrListModule {}
